import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type MessageVariantType, messageVariantList } from '../../typings/messageVariantType';
import { defaults } from '../defaults';

export const withMessageVariantProps = {
  /**
   * Wariant wiadomości
   */
  variant: { type: String as PropType<MessageVariantType>, default: defaults.message.variant }
};

/**
 * Zwraca klasę wariantu wiadomości
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withMessageVariantProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useMessageVariantProps = (prefix: string, props: ExtractPropTypes<typeof withMessageVariantProps>) => {
  return computed(() => ({
    [`${prefix}--${props.variant}`]: props.variant !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesMessageVariantArgs = {
  args: {
    variant: defaults.button.variant
  },

  argTypes: {
    variant: {
      options: messageVariantList,
      control: { type: 'select' }
    }
  }
};
